import { BulletList, LinkBase, Text } from '@belong/ui';
import { StaticLandingPageLink } from 'src/features/homeowners/homeowners.types';

type Props = {
  neighborhoods: StaticLandingPageLink[];
};

export function NeighborhoodList({ neighborhoods }: Props) {
  return (
    <BulletList
      wrap
      items={neighborhoods.map((neighborhood) => {
        return (
          <LinkBase key={neighborhood.href} href={neighborhood.href}>
            <Text as="span" className="hover:text-dark-navy">
              {neighborhood.displayName}
            </Text>
          </LinkBase>
        );
      })}
      size="large"
    />
  );
}
